/**
 * Shown in the Sharing & Access tooltip and again as the confirmation modal's description, so it
 * lives here rather than being duplicated at each surface.
 */
export const CARE_CODE_DESCRIPTION = 'Create a printable sheet with a code anyone can scan with their phone’s camera to see how things are going. Good for the fridge or by the front door, and it stays active for a year!';
